import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";

export const fetchInfoBranch = createAsyncThunk(
    "show/branch-info/fetchData",
    async ({ branchId, perPage }) => {
        try {

            const response = await api.get("/info-branches", { params: { branch_id: branchId,  perPage } });
            console.log("response:", response);
            if (response.data?.status === "success") {
                const data = response.data.data;
                return { data: data, total: response.data.total };
            }
        } catch (error) {
            return error;
        }
    }
);

export const branchInfoSlice = createSlice({
    name: "branchInfo",
    initialState: {
        loading: false,
        error: null,
        data: [],
        total: 0
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchInfoBranch.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchInfoBranch.fulfilled, (state, action) => {

                state.loading = false;
                state.data = action.payload.data;
                state.total = action.payload.total;
            })
            .addCase(fetchInfoBranch.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },

});

export default branchInfoSlice.reducer;

